import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';

const AssistantIcon: React.FC<StylovyzeIconProps> = ({ color }) => {
  const fill = color || 'currentColor';

  return (
    <svg
      width="28"
      height="21"
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2187 0.904638L1.08972 10.9831C0.487882 11.3592 0.304863 12.1519 0.68093 12.7538C1.057 13.3556 1.84974 13.5386 2.45158 13.1626L18.5805 3.08407C19.1824 2.708 19.3654 1.91526 18.9893 1.31342C18.6133 0.71159 17.8205 0.528571 17.2187 0.904638Z"
        fill={fill}
      />
      <path
        d="M25.5478 0.840654L1.08972 16.1238C0.487882 16.4998 0.304863 17.2926 0.68093 17.8944C1.057 18.4962 1.84974 18.6793 2.45158 18.3032L26.9097 3.02009C27.5115 2.64402 27.6945 1.85127 27.3184 1.24944C26.9424 0.647607 26.1496 0.464587 25.5478 0.840654Z"
        fill={fill}
      />
      <path
        d="M25.1935 6.55019L8.45983 17.0066C7.858 17.3826 7.67498 18.1754 8.05105 18.7772C8.42711 19.379 9.21986 19.5621 9.82169 19.186L26.5554 8.72962C27.1572 8.35355 27.3403 7.56081 26.9642 6.95897C26.5881 6.35714 25.7954 6.17412 25.1935 6.55019Z"
        fill={fill}
      />
      <path
        d="M25.1898 6.49132L22.6649 8.06907C22.0631 8.44514 21.8801 9.23788 22.2561 9.83972C22.6322 10.4415 23.4249 10.6246 24.0268 10.2485L26.5517 8.67075C27.1535 8.29468 27.3366 7.50194 26.9605 6.9001C26.5844 6.29827 25.7917 6.11525 25.1898 6.49132Z"
        fill={fill}
      />
      <path
        d="M25.5481 11.4088L16.6522 16.9675C16.0504 17.3436 15.8674 18.1363 16.2434 18.7382C16.6195 19.34 17.4122 19.523 18.0141 19.1469L26.9099 13.5882C27.5118 13.2121 27.6948 12.4194 27.3187 11.8176C26.9426 11.2157 26.1499 11.0327 25.5481 11.4088Z"
        fill={fill}
      />
      <path
        d="M24.7645 17.1823L24.7645 17.1824C24.1627 17.5584 23.9797 18.3512 24.3557 18.953C24.7318 19.5548 25.5245 19.7378 26.1264 19.3618L26.1264 19.3618C26.7282 18.9857 26.9112 18.193 26.5352 17.5911C26.1591 16.9893 25.3664 16.8063 24.7645 17.1823Z"
        fill={fill}
      />
      <defs>
        <linearGradient
          id="paint0_linear_9595_4947"
          x1="23.6207"
          y1="7.7271"
          x2="7.43147"
          y2="17.9449"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.65" />
          <stop offset="0.510417" stopOpacity="0.25" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AssistantIcon;
